<template>
  <v-data-table v-bind="vBind" :getFreshData="true" :rowClick="rowClick"></v-data-table>
</template>

<script>
import * as tariff_list from "../plugins/objects/tariff_list";
export default {
  components: {
    VDataTable: () => import("../components/Table.vue"),
  },
  data() {
    return {
      vBind: tariff_list.getVBind(window.portal_id),
    };
  },
  methods: {
    rowClick: function (item) {
      var tariff = {};
      tariff._id = item._id;
      tariff.text = "#" + item.tariff_name;
      tariff.link = "/tariff/" + item._id;
      this.$router.push({ path: tariff.link });
      this.$root.$emit("routeChanged", "tariff");
    },
  },
};
</script>
